import { getOptions } from 'components/common/InputSelect/inputSelect.utils';
import {
  PrimaryHomeImprovementCategory,
  CompanyInformationFieldName,
  MainContactPosition,
} from 'components/intermediaryApplications/intermediaryApplications.enums';

export const PRIMARY_HOME_IMPROVEMENT_CATEGORY_OPTIONS = getOptions(PrimaryHomeImprovementCategory);
export const MAIN_CONTACT_POSITION_OPTIONS = getOptions(MainContactPosition);
export const ADDITIONAL_EMAILS_FIELD_NAME = [
  CompanyInformationFieldName.SecondEmail,
  CompanyInformationFieldName.TertiaryEmail,
  CompanyInformationFieldName.QuaternaryEmail,
];
export const MAX_SALESPERSONS_AMOUNT = 30;
export const TEAM_MEMBER_POLLING_INTERVAL_MS = 2000;
export const TEAM_MEMBER_POLLING_MAX_DURATION_MS = 16000;
